
import { Component, Prop, Vue } from "vue-property-decorator";

@Component({
  name: "WatchlistList",
})
export default class WatchlistList extends Vue {
  @Prop({ type: String, required: false, default: "de" })
  private readonly locale!: string;

  @Prop({ type: Number, required: false, default: 10 })
  private readonly itemsPerPage!: number;

  public onTableRowClick(payload: object) {
    window.dispatchEvent(
      new CustomEvent("watchlist-list-row-clicked", { detail: payload })
    );
  }
  public onTableRowKeyClick(payload: object) {
    window.dispatchEvent(
      new CustomEvent("watchlist-list-row-key-clicked", { detail: payload })
    );
  }
}
